const containgActiveOrientation = ((template) => {
  const activeOrientation = (() => {
    const { tags } = window.activeView.template;
    return ['is-landscape', 'is-portrait', 'is-square'].find((tag) => tags.includes(tag));
  })();

  return template.tags.includes(activeOrientation);
});

export default containgActiveOrientation;
